import {LocationMiscellaneousCertificationModel} from './location-miscellaneous-certification.model';

export class EquipmentDetailModel {
    id?: string | null = null;
    client?: string | null = null;
    projectName?: string | null = null;
    tag?: string | null = null;
    // type?: string | null = null;
    electricalCircuitConnection?: string | null = null;
    electricalAndProcessDrawing?: string | null = null;
    equipmentClassification?: string | null = null;
    fieldEquipmentAssociatedApparatus?: string | null = null;
    ipx?: string | null = null;
    ipy?: Array<string> = [];
    equipmentType?: string | null = null;
    manufacturer?: string | null = null;
    supplier?: string | null = null;
    modelNo?: string | null = null;
    serialNo?: string | null = null;
    zone?: string | null = null;
    flammableSubstances?: string | null = null;
    explosionConsequences?: string | null = null;
    gasDustGroup?: string | null = null;
    dustIgnitionTempRequired?: string | null = null;
    temperatureClass?: string | null = null;
    environmentalCondition?: string | null = null;
    exMarketing?: string | null = null;
    iecex?: string | null = null;
    xur?: string | null = null;
    inspectionFrequency?: string | null = null;
    certificationNumber?: string | null = null;
    certificationScheme?: Array<string> = [];
    protectionTechniqueGas?: Array<string> = [];
    protectionTechniqueEplGas?: Array<string> = [];
    protectionTechniqueDust?: Array<string> = [];
    protectionTechniqueEplDust?: Array<string> = [];
    eplGasAndDust?: string | null = null;
    eplGasAndDustSub?: string | null = null;
    epl?: string | null = null;
    classificationGasDustGroup?: string | null = null;
    classificationTemperatureClass?: string | null = null;
    maxSurfaceTempWithDustLayerMM?: string | null = null;
    maxSurfaceTempWithDustCloud?: string | null = null;
    ambientTemp?: string | null = null;
    equipmentAmbientTemp?: string | null = null;
    approvalType?: string | null = null;

    public wiringProtectionTechnique: Array<string> = [];

    powerCableType?: string | null = null;
    powerCableModel?: string | null = null;
    powerCableManufacturer?: string | null = null;
    powerCableOther?: string | null = null;
    powerCableElecFrom?: string | null = null;
    signalCableType?: string | null = null;
    signalCableModel?: string | null = null;
    signalCableManufacturer?: string | null = null;
    signalCableOther?: string | null = null;
    signalCableFrom?: string | null = null;
    signalCableTo?: string | null = null;

    note?: string | null = null;

    created?: Date | null = null;
    updated?: Date | null = null;

    locationId?: string | null = null;

    combinationOptionGas?: string | null = null;

    lowAmbientTemperature?: string | null = null;
    highAmbientTemperature?: string | null = null;
    lowServiceTemperature?: string | null = null;
    highServiceTemperature?: string | null = null;
    dustLayerIgnition?: string | null = null;
    dustLayerDepth?: string | null = null;
    dustTemperatureClass?: string | null = null;
    dustGroupf?: string | null = null;
    gasTemperatureClass?: string | null = null;
    gasGroupf?: string | null = null;
    iPYrequirement?: string | null = null;
    iPXrequirement?: string | null = null;

    fieldEquipApparatus?: string | null = null;
    divisionForRiskLevel?: string | null = null;
    installedDate?: string | null = null;
    powerType?: string | null = null;
    ACDC?: string | null = null;
    divisionRiskLevel?: string | null = null;

    warningMarkingInformation?: string | null = null;
    exComponentInformationf?: string | null = null;
    powerACDC?: string | null = null;
    phasesf?: string | null = null;
    converterNamef?: string | null = null;
    voltageVf?: string | null = null;
    frequencyHzf?: string | null = null;
    minVoltageVf?: string | null = null;
    minFrequencyHzf?: string | null = null;
    maxVoltageVf?: string | null = null;
    maxFrequencyHzf?: string | null = null;
    suffixf?: string | null = null;
    ePLGas?: string | null = null;
    ePLDust?: string | null = null;
    maxSurfaceTempf?: string | null = null;
    testDustLayerf?: string | null = null;
    maxSurfaceTempWithDustLayerCf?: string | null = null;
    specialConditionsUsef?: string | null = null;

    miscellaneousCertification?: LocationMiscellaneousCertificationModel | null = null;

    constructor(data?: Partial<EquipmentDetailModel>) {
        Object.assign(this, data);
        if (!this.miscellaneousCertification) {
            this.miscellaneousCertification = new LocationMiscellaneousCertificationModel();
        }
    }
}
